/** 
 Copyright Highway9 Networks Inc. 
 */ 
import APIService from "./APIServices";

const BotAPI = new APIService<any>('chatbot')

export const botService = {
    sendFeedback : async(id : string , feedback : number) => {
        return BotAPI.post(`chatbot/feedbacks/${id}`, { feedback })
    }
}
